import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {ConfigPage} from './config';
import {TranslateModule} from "@ngx-translate/core";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    ConfigPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(ConfigPage),
    TranslateModule.forChild()
  ],
})
export class ConfigPageModule {}



// WEBPACK FOOTER //
// ./src/pages/config/config.module.ts